"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDatasheetValidationsSchema = exports.PackageDatasheetValidationSchema = exports.PackageDatasheetReplacementSearchSchema = exports.DatasheetReplacementOutcome = exports.MATCHING_DATASHEET_VERDICT_KINDS = exports.DatasheetValidationVerdictKind = exports.DatasheetValidationOverridableStatusSchema = exports.DatasheetValidationStatus = void 0;
exports.parsePackageDatasheetValidations = parsePackageDatasheetValidations;
exports.effectiveDatasheetValidationStatus = effectiveDatasheetValidationStatus;
const zod_1 = require("zod");
var DatasheetValidationStatus;
(function (DatasheetValidationStatus) {
    DatasheetValidationStatus["Valid"] = "valid";
    DatasheetValidationStatus["Invalid"] = "invalid";
    DatasheetValidationStatus["Failed"] = "failed";
})(DatasheetValidationStatus || (exports.DatasheetValidationStatus = DatasheetValidationStatus = {}));
exports.DatasheetValidationOverridableStatusSchema = zod_1.z.union([
    zod_1.z.literal(DatasheetValidationStatus.Valid),
    zod_1.z.literal(DatasheetValidationStatus.Invalid),
]);
var DatasheetValidationVerdictKind;
(function (DatasheetValidationVerdictKind) {
    DatasheetValidationVerdictKind["ExactPart"] = "exact_part";
    DatasheetValidationVerdictKind["FamilyDatasheet"] = "family_datasheet";
    DatasheetValidationVerdictKind["WrongPart"] = "wrong_part";
    DatasheetValidationVerdictKind["WrongManufacturer"] = "wrong_manufacturer";
    DatasheetValidationVerdictKind["ProductOverview"] = "product_overview";
    DatasheetValidationVerdictKind["OtherDocument"] = "other_document";
    DatasheetValidationVerdictKind["NotAPdf"] = "not_a_pdf";
})(DatasheetValidationVerdictKind || (exports.DatasheetValidationVerdictKind = DatasheetValidationVerdictKind = {}));
exports.MATCHING_DATASHEET_VERDICT_KINDS = [
    DatasheetValidationVerdictKind.ExactPart,
    DatasheetValidationVerdictKind.FamilyDatasheet,
];
var DatasheetReplacementOutcome;
(function (DatasheetReplacementOutcome) {
    DatasheetReplacementOutcome["Replaced"] = "replaced";
    DatasheetReplacementOutcome["CandidateRejected"] = "candidate_rejected";
    DatasheetReplacementOutcome["NotFound"] = "not_found";
    DatasheetReplacementOutcome["NotAttached"] = "not_attached";
    DatasheetReplacementOutcome["Failed"] = "failed";
})(DatasheetReplacementOutcome || (exports.DatasheetReplacementOutcome = DatasheetReplacementOutcome = {}));
exports.PackageDatasheetReplacementSearchSchema = zod_1.z.object({
    outcome: zod_1.z.nativeEnum(DatasheetReplacementOutcome),
    candidateFileId: zod_1.z.string().optional(),
    searchedAt: zod_1.z.string(),
});
exports.PackageDatasheetValidationSchema = zod_1.z.object({
    status: zod_1.z.nativeEnum(DatasheetValidationStatus),
    reasoning: zod_1.z.string(),
    kind: zod_1.z.nativeEnum(DatasheetValidationVerdictKind).optional(),
    passesPdfSignatureCheck: zod_1.z.boolean().optional(),
    workflowId: zod_1.z.string(),
    runId: zod_1.z.string(),
    validatedAt: zod_1.z.string(),
    statusOverride: exports.DatasheetValidationOverridableStatusSchema.optional(),
    overriddenBy: zod_1.z.string().optional(),
    overriddenAt: zod_1.z.string().optional(),
    overrideNote: zod_1.z.string().optional(),
    replacementSearch: exports.PackageDatasheetReplacementSearchSchema.optional(),
    replacedFileId: zod_1.z.string().optional(),
});
exports.PackageDatasheetValidationsSchema = zod_1.z.record(zod_1.z.string(), exports.PackageDatasheetValidationSchema);
function parsePackageDatasheetValidations(metadata) {
    if (metadata === null || metadata === undefined || typeof metadata !== 'object') {
        return undefined;
    }
    const candidate = metadata['datasheetValidations'];
    if (candidate === undefined) {
        return undefined;
    }
    const parsed = exports.PackageDatasheetValidationsSchema.safeParse(candidate);
    return parsed.success ? parsed.data : undefined;
}
function effectiveDatasheetValidationStatus(validation) {
    return validation === undefined ? undefined : (validation.statusOverride ?? validation.status);
}
//# sourceMappingURL=package-datasheet-validation.js.map